<template>
  <base-step
    :title="trans('guided_search.budget.title')"
    :title-precision="trans('guided_search.extended_title.approximately')"
    main-class="budget-step-container"
  >
    <template #content>
      <div class="budget-step-container__input">
        <div class="input-text input-text--legend input-icon">
          <input
            v-model="budget.value"
            type="text"
            inputmode="numeric"
            name="budget"
            :placeholder="trans('guided_search.input.placeholder')"
            :class="{ error: budget.touched && isStepBudgetDisabled }"
            @input="updateStore()"
            @blur="budget.touched = true"
          >
          <span>
            {{ trans('global.no_tax_per_month') }}
          </span>
          <label v-if="budget.touched && isStepBudgetDisabled">
            {{ trans('global.form.field.invalid', { field: trans('guided_search.budget.field') }) }}
          </label>
          <label v-if="isStepBudgetMaxAmountExceeded">{{ trans('guided_search.budget.max_amount_exceeded') }}</label>
        </div>
      </div>
      <span class="budget-step-container__toggle">
        <toggle :value="isUnknown" :label="trans('guided_search.toggle.i_dont_know.advice')" @onchange="toggleBudget" />
      </span>
    </template>
  </base-step>
</template>

<script>
import Toggle from '@components/Toggle.vue';
import { inputNumber } from '@elements/number-formatter';
import { translationMixin } from '@elements/translation';
import { guidedSearchMixin } from '@organisms/guided-search/guidedSearchMixin';
import BaseStep from './BaseStep.vue';

export default {
  name: 'Budget',
  components: { Toggle, BaseStep },
  mixins: [ guidedSearchMixin, translationMixin ],
  data() {
    return {
      budget: {
        value: null,
        touched: false,
      },
    };
  },
  computed: {
    customerBudget: {
      get() {
        return this.store.stepValues.budget.price;
      },
      set(value) {
        this.store.setStepValue({ step: 'budget', stepDetails: 'price', value });
      },
    },
    isUnknown: {
      get() {
        return this.store.stepValues.budget.isUnknown;
      },
      set(value) {
        this.store.setStepValue({ step: 'budget', stepDetails: 'isUnknown', value });
      },
    },
  },
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'budget',
      step: 'budget',
      funnel: 'support-contact-form',
    });
  },
  methods: {
    setBudget(priceNumber) {
      this.budget.value = inputNumber(priceNumber?.toString() ?? '');
      this.customerBudget = priceNumber;
    },

    getOnlyNumbersDigit(budget) {
      const parsedBudget = budget.replace(/\D/g, '');

      if (parsedBudget.length === 0) {
        return null;
      }

      return parsedBudget;
    },

    toNumber(budgetString) {
      return Number.parseInt(budgetString, 10);
    },

    updateStore() {
      const numbers = this.getOnlyNumbersDigit(this.budget.value);

      if (!numbers) {
        this.budget.value = null;
        return;
      }

      this.setBudget(this.toNumber(numbers));

      this.isUnknown = !this.budget.value;
    },

    toggleBudget() {
      this.isUnknown = !this.isUnknown;

      if (this.isUnknown) {
        this.setBudget(null);
      }
    },
  },
};
</script>
